import {ElementRef, Injectable} from '@angular/core';
import {SearchResultEntry} from "../../../api/models/search-result-entry";
import {SearchUrlParameters} from "../../model/search-url-parameters";
import {SearchResult} from "../../../api/models/search-result";
import {LocaleService} from "../../locale/locale.service";
import {BehaviorService} from "../../../api/services/behavior.service";
import { ClickParams } from '../../../api/models/click-params';


const DEFAULT_TYPE = "result";

@Injectable({
  providedIn: 'root'
})
export class SignalService {

  lastSearchParams?: SearchUrlParameters;
  lastSearchResult?: SearchResult;

  constructor(private localeService: LocaleService,
              private behaviorService: BehaviorService) {
  }

  sendSignal(result: SearchResultEntry, elementHref: string) {

    const params: ClickParams = {
      offset: this.getOffset(),
      pos: typeof result.documentNumber === 'number' ? result.documentNumber - this.getOffset() : 0,
      clickType: DEFAULT_TYPE,
      url: elementHref,
      signalContext: this.lastSearchResult?.signalContext
    };

    const signalUrl = this.behaviorService.rootUrl + BehaviorService.RecordClickPath;
    const blob = new Blob([JSON.stringify(params)], {type : 'application/json'});
    navigator.sendBeacon(signalUrl, blob);
  }


  private getOffset(): number {
    const ps = this.lastSearchParams?.ps || 10;
    const pg = this.lastSearchParams?.pg || 1;
    return (pg - 1) * ps;
  }


}
